export const messages = {
  pl: {
    message: {
      title: 'CONFI-DSO',
      system_zasilania: 'System zasilania DSO-PRA',
      cluster: 'Klaster',
      clusters: 'Klastry',
      desc: 'Opis',
      device: 'Urządzenie',
      devices: 'Urządzenia',
      input_data: 'Dane wejściowe',
      output_data: 'Dane wyjściowe',
      accessories: 'Akcesoria',
      quantity: 'Ilość',
      multifunction: 'Zasilacz wielofunkcyjny',
      output24: 'Wyjście 24VDC',
      output48: 'Wyjście 48VDC',
      callStation: 'Stacja wywoławcza desktop/naścienna',
      mpsActiveEthernet: 'Aktywne porty Ethernet',
      mpsActiveSfp: 'Aktywny porty sfp',
      systemController: 'PRA-SCL (Sterownik systemu)',
      otherDevice: 'inne urządzenie',
      maxCurrent: 'Maksymalny prąd [mA]@24V',
      heightOtherDivice: 'Wysokość montażowa U',
      channel: 'kanały',
      totalLoudspeaker: 'Całkowite obciążenie głośnika [W]',
      totalPoE: 'Całkowite obciążenie PoE [watt]',
      currentQuiescent: 'Prąd w stanie spoczynku [mA]@48V',
      currentAlarm: 'Prąd podczas alarmu [mA] przy 48V',
      callStationDesktop: 'Stacja wywoławcza desktop',
      callStationWall: 'Stacja wywoławcza naścienna',
      callStationExt: 'Rozszerzenie stacji wywoławczej',
      totalPoeCST: 'Aktywne porty PoE (dla wszystkich stacji)',
      classEmerdencyCST: 'Ilość stacji alarmowych',
      requiredBattery: 'Wymagana pojemność akumulatora wraz z współczynnikiem bezpieczeństwa (100 - 230Ah)',
      maxBattery: 'Maksymalny prąd akumulatora (sprawdź specyfikację akumulatora)',
      mainsCurrent230: 'Pobór prądu sieciowego przy 230 VAC (podczas alarmu i maksymalnego ładowania akumulatora)',
      mainsCurrent115: 'Pobór prądu sieciowego przy 115 VAC (podczas alarmu i maksymalnego ładowania akumulatora)',
      myRequiredBattery: 'Dobrany akumulator automatycznie / przez użytkownika',
      totalLossPower: 'Całkowita strata mocy wzmacniaczy',
      totalLossHeat: 'Całkowita utrata ciepła (odprowadzanie ciepła w szafie)',
      totalLossKcal: 'Całkowita strata ciepła',
      idle: 'bezczynny',
      full: 'pełny',
      active: 'aktywny',
      new: 'Nowa konfiguracja',
      save: 'Zapisz',
      open: 'Otwórz',
      about_program: 'O programie',
      documentations: 'Dokumentacja',
      address: 'Dane adresowe',
      results: 'Podsumowanie',
      height_u: 'Wysokość szafy RACK',
      height_mm: 'Wysokość szafy RACK',
      dimensions_rack: 'Rozmiar szafy RACK',
      weight_rack: 'Waga szafy RACK',
      weight_battery: 'Waga akumulatorów',
      weight_system: 'Waga instalacyjna (z akumulatorami i urządzeniami)',
      keyGen: 'Numer konfiguracji',
      clearCluster: 'wyczyść obecny klaster',
      changeBattery: 'zmień akumulator',
      selectBattery: 'Wybierz akumulator',
      close: 'zamknij',
      hold_time: 'Czas podtrzymania [h]',
      alarm_time: 'Czas alarmowania [h]',
      extra_u: 'Dodatkowe miejsce U w szafie',
      inc_safety: 'Współczynnik bezpieczeństwa [%]',
      depth_cabinet: 'Głębokość szafy [mm]',
      depth_cabinet_info: 'Głębokość szafy 600 lub 800mm<br>w zależności od wysokości szafy',
      wheels: 'Zestaw kółek',
      fan: 'Panel wentylacyjny z termostatem',
      DSOS24VPU: 'DSOS24VPU - obudowa mikrofonu strażaka',
      DSOS24VPU_info: 'Mikrofon strażaka umieszczony w oddzielnej/osobnej obudowie DSOS24VPU.',
      DSOS24V_PRA: 'DSOS24V-PRA - zasilacz mikrofonu strażaka',
      DSOS24V_PRA_info: 'Zasilacz DSOS24V-PRA przeznaczony jest do bezprzerwowego zasilania stacji<br>wywoławczej (mikrofonu strażaka) pracującej w systemie DSO wymagającej<br>stabilizowanego napięcia 48 V DC.',
      extension: 'rozszerzenia',
      enclosure_loudspeaker: 'Obudowa płytki końca lini',
      shelf: 'Półka na mikrofon strażaka',
      contracting: 'Zamawiający',
      company_contracting: 'Firma zamawiająca',
      company_name: 'Nazwa firmy',
      address_title: 'Adres',
      city: 'Miasto',
      phone: 'Tel',
      eMail: 'eMail',
      nip: 'NIP',
      investment: 'Inwestycja',
      address_shipping: 'Adres wysyłki',
      investment_name: 'Nazwa inwestycji',
      phone_contact: 'Telefon kontaktowy',
      email_contact: 'eMail kontaktowy',
      check_other_address: 'zaznacz jeżeli inny adres wysyłki',
      name_surname: 'Imię i nazwisko',
      save_form: 'zapisz formularz',
      clear_form: 'wyczyść formularz',
      printout: 'wydruk',
      cost: 'wycena',
      count_pcs: 'Ilość sztuk',

      info_01: 'Program CONFI-DSO PRAESENSA oblicza zapotrzebowanie mocy systemu DSO PRAESENSA. System umożliwia obliczenia dla 6 układów zasilania w pojedynczej szafie RACK. Każdy układ zasilania/klaster składa się z jednego zasilacza PRA-MPS3 i podłączonych do niego urządzeń, które będą zasilane. Dla każdej następnej szafy DSO należy wykonać nowe obliczenia.',

      info_02: 'Uwaga: należy przestrzegać maksymalnego prądu akumulatora, gdy różni się on znacznie w zależności od zastosowanych akumulatorów.',

      info_03: 'Kalkulator mocy służy wyłącznie jako narzędzie pomocnicze. Nie może zastąpić fachowej porady ekspertów technicznych. Aby uzyskać więcej informacji, nasz zespół sprzedaży i wsparcia może pomóc w prawidłowym doborze odpowiednich parametrów systemu. Firma PULSAR nie gwarantuje, że narzędzie spełni jakiekolwiek szczególne lub ogólne wymagania użytkownika i zrzeka się jakiejkolwiek gwarancji przydatności do określonego celu. W zakresie dozwolonym przez prawo PULSAR nie ponosi żadnej odpowiedzialności za jakiekolwiek straty, uszkodzenia lub inne konsekwencje wynikające z użycia narzędzia.',
      trans: 'wycena nie zawiera kosztu transportu',
      info_o_zamowieniu: 'przed złożeniem zamówienia prosimy o ponowne sprawdzenie konfiguracji<br>ze względu na możliwe zmiany cen poszczególnych elementów składowych systemu',
      przylacze_zasilania: 'Przyłącze zasilania',
      faza1: '1-fazowe 230',
      faza3: '3-fazowe 3x230/400',
      cena_netto_systemu: 'Cena netto systemu',
      cena_netto_bez_rabatu: 'Cena netto bez rabatu',
      wycena_z_akumulatorem: 'Wyceń z akumulatorem',
      wycena_bez_akumulatora: 'Pomiń wycene akumulatora',
      wyposazenie: 'Wyposażenie dodatkowe',
      zasilacz_mps: 'Uwaga! Każdy zasilacz MPS ma 2 porty PoE.<br>Wymagane są dodatkowe porty PoE (dodaj np. Switch).',
      rabat: 'Rabat',
      waluta: '[PLN]',
      cena_net_szt_pln: 'Cena netto sztuka po rabacie [PLN]',
      wartosc_net_rabat: 'Wartość netto po rabacie [PL]',
      cena_netto_sztuka: 'Cena netto sztuka',
      cena_netto_sztuka_rabat: 'Cena netto sztuka<br>po rabacie',
      wartosc_netto: 'Wartość netto',
      wartosc_netto_rabat: 'Wartość netto<br>po rabacie',
      ilosc_urzadzen_poza_szafa: 'Ilość urządzeń wychodzi poza szafę',
      brak_miejsca_na_urzadzenia: 'Brak możliwości zamontowania więcej urządzeń (brak miejsca w szafie)',
      brak_akumulatora_w_konfiguracji: 'Brak akumulatora spełniającego konfigurację w klastrze',
      przywroc_glebokosc_szafy: 'Przywróć automatycznie głębokość szafy',
      instrukcja_programu: 'Instrukcja programu',
      noiseSensor: 'Czujnik poziomu hałasu',
      interfaceControl: 'Moduł interfejsu sterującego',
      interfaceAudio: 'Moduł interfejsu audio',
      panelControl: 'Ścienny panel sterowania',
      active_ports_mps_and_switch: 'Aktywne porty PoE MPS i switch',
      products_bosch: 'produkty marki BOSCH nie są objęte podaną ceną'
    }
  },
  en: {
    message: {
      title: 'CONFI-DSO',
      system_zasilania: 'VAS-PRA Power Supply system',
      cluster: 'Cluster',
      clusters: 'Clusters',
      desc: 'Description',
      device: 'Device',
      devices: 'Devices',
      input_data: 'Input data',
      output_data: 'Output data',
      accessories: 'Accessories',
      quantity: 'Quantity',
      multifunction: 'Multifunction Power Supply',
      output24: '24VDC output',
      output48: '48VDC output',
      callStation: 'Call station desktop/wallmount',
      mpsActiveEthernet: 'Active Ethernet ports on MPS',
      mpsActiveSfp: 'Active SFP ports on MPS',
      systemController: 'PRA-SCL (System controller)',
      otherDevice: 'other device',
      maxCurrent: 'Maximum current [mA]@24V',
      heightOtherDivice: 'Mounting height U',
      channel: 'channel',
      totalLoudspeaker: 'Total loudspeaker load [W]',
      totalPoE: 'Total PoE load 3rd party devices [watt]',
      currentQuiescent: 'Current in quiescent mode [mA]@48V',
      currentAlarm: 'Current during alarm [mA]@48V',
      callStationDesktop: 'Call station desktop',
      callStationWall: 'Call station wallmount',
      callStationExt: 'Call station extension',
      totalPoeCST: 'Active PoE ports (total of all CST`s)',
      classEmerdencyCST: 'Amount of CST`s with class Emergency',
      requiredBattery: 'Required battery capacity incl. safety factor (100 - 230Ah)',
      maxBattery: 'Maximum battery current (check battery specification)',
      mainsCurrent230: 'Mains current draw at 230 V AC (during alarm and maximum battery charging)',
      mainsCurrent115: 'Mains current draw at 115 V AC (during alarm and maximum battery charging)',
      myRequiredBattery: 'Battery selected automatically / by the user',
      totalLossPower: 'Total power loss of amplifiers',
      totalLossHeat: 'Total heat loss (heat dissipation within the rack)',
      totalLossKcal: 'Total heat loss',
      idle: 'idle',
      full: 'full',
      active: 'Active',
      new: 'New',
      save: 'Save',
      open: 'Open',
      about_program: 'About program',
      documentations: 'Documents',
      address: 'Address data',
      results: 'Results',
      height_u: 'RACK cabinet height',
      height_mm: 'RACK cabinet height',
      dimensions_rack: 'RACK size',
      weight_rack: 'RACK cabinet weight',
      weight_battery: 'Battery weight',
      weight_system: 'Installation weight (with batteries and devices)',
      keyGen: 'Configuration code',
      clearCluster: 'clear cluster',
      changeBattery: 'change battery',
      selectBattery: 'Select battery',
      close: 'close',
      hold_time: 'Hold time [h]',
      alarm_time: 'Alarm time [h]',
      extra_u: 'Extra space U in the cabinet',
      inc_safety: 'Incl. safety [%]',
      depth_cabinet: 'Rack depth [mm]',
      depth_cabinet_info: 'Cabinet depth: 600 or 800mm<br>depending on the cabinet height.',
      wheels: 'Wheels set',
      fan: 'Fan unit with thermostat',
      DSOS24VPU: 'DSOS24VPU - enclosure for firefighter’s microphone',
      DSOS24VPU_info: 'Firefighter`s microphone mounted in the DSOS24VPU external enclosure.',
      DSOS24V_PRA: 'DSOS24V-PRA - Firefighter`s microphone power supply',
      DSOS24V_PRA_info: 'DSOS24V-PRA is designed for uninterruptible power supply of call stations (firefighter`s microphone) used in DSO (Voice Alarm Systems) requiring stabilized voltage of 48 V DC.',
      extension: 'extension',
      enclosure_loudspeaker: 'Enclosure for loudspeaker line supervision',
      shelf: 'Firefighter’s microphone shelf',
      contracting: 'Contracting',
      company_contracting: 'Contracting company',
      company_name: 'Company name',
      address_title: 'Address',
      city: 'City',
      phone: 'Phone',
      eMail: 'e-Mail',
      nip: 'NIP',
      investment: 'Investment',
      address_shipping: 'Shipping address',
      investment_name: 'Name of the investment',
      phone_contact: 'Phone contact',
      email_contact: 'e-Mail contact',
      check_other_address: 'check if another shipping addres',
      name_surname: 'Name and last name',
      save_form: 'Save form',
      clear_form: 'Clear form',
      printout: 'printout',
      cost: 'Summary',
      count_pcs: 'Quantity',

      info_01: 'This tool calculates the power requirements for a PRAESENSA system. It calculates up to 6 clusters. A cluster consists of one PRA-MPS3 and the connected devices to be supplied with power. Use the safety factor in the calculation of the battery capacity to compensate the tolerances of battery brands and types. Please also check the rack space requirements for the calculated battery types. For each additional rack a new calculation has to be made.',

      info_02: 'Special Note: Maximum battery current must be observed while it highly varies among different battery types.',

      info_03: 'The Power calculator serves as a support tool only. It cannot substitute professional advice from technical experts. For further details, our sales and support team will be happy to assist. Bosch does not warrant that the tool will fulfill any specific or general user requirement and disclaims any warranty for fitness for a specific purpose. To the extent permitted by law, Bosch will not accept any liability for any loss, damage or other consequences resulting from the use of the tool.',
      trans: 'the quotation does not include transport costs',
      info_o_zamowieniu: 'before placing an order, please double-check the configuration due to possible price changes of individual system components',
      przylacze_zasilania: 'Power connection',
      faza1: '1-phase 230',
      faza3: '3-phase 3x230/400',

      wycena_z_akumulatorem: 'Include battery in quote',
      wycena_bez_akumulatora: 'Exclude battery from quote',
      wyposazenie: 'Additional equipment:',
      zasilacz_mps: 'Note! Each MPS power supply has 2 PoE ports.<br>Additional PoE ports are required (e.g., add a switch).',
      rabat: 'Discount',
      waluta: '[EUR]',
      cena_netto_systemu: 'Net price of the system',
      cena_netto_bez_rabatu: 'Net price without discount',
      cena_net_szt_pln: 'Net price per unit after discount [EUR]',
      wartosc_net_rabat: 'Net value after discount [EUR]',
      cena_netto_sztuka: 'Net price per item',
      cena_netto_sztuka_rabat: 'Net price per item<br>after discount',
      wartosc_netto: 'Net value',
      wartosc_netto_rabat: 'Net value<br>after discount',
      ilosc_urzadzen_poza_szafa: 'The number of devices exceeds the rack capacity',
      brak_miejsca_na_urzadzenia: 'Cannot install more devices (no space in the rack)',
      brak_akumulatora_w_konfiguracji: 'No battery available that matches the configuration in the cluster',
      przywroc_glebokosc_szafy: 'Automatically restore rack depth',
      instrukcja_programu: 'Instruction',
      noiseSensor: 'Ambient noise sensor',
      interfaceControl: 'Control interface module',
      interfaceAudio: 'Audio interfejsu module',
      panelControl: 'Wall control panel',
      active_ports_mps_and_switch: 'Active PoE ports on MPS and switch',
      products_bosch: 'Bosch products are not included in the quoted price'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/messages.js